const DECIMAL_PRECISION_EPSILON = 1e-8;

export function hasUpToDecimalPlaces(value: number, places: number): boolean {
  const factor = 10 ** places;
  const scaled = value * factor;
  return (
    Number.isFinite(scaled) &&
    Math.abs(scaled - Math.round(scaled)) < DECIMAL_PRECISION_EPSILON
  );
}

export function isWholeNumber(value: number): boolean {
  return Number.isFinite(value) && Number.isInteger(value);
}
